module.exports = require('./helpers/bundle-url').getBundleURL('hG7gn') + "logo-dark.eefe0b7f.svg";